<template>
	<div>
		<v-subheader class="font-weight-bold pa-0">
			{{ $t("label.driver") }}
			<v-chip
				:color="order.delivery_status_color"
				class="ml-5"
				dark
				x-small
				outlined
				v-if="order.delivery_status_label"
			>
				{{ order.delivery_status_label }}
			</v-chip>
		</v-subheader>
		<v-btn
			v-if="order.driver"
			outlined
			color="primary"
			:href="
				$route('tenant.drivers.show', {
					tenant: $page.props.tenant.id,
					driver: order.driver.uuid,
				})
			"
			target="_blank"
			class="mb-3"
		>
			<v-icon left>mdi-moped-outline</v-icon>
			{{ order.driver.name }}
			<v-icon right>mdi-open-in-new</v-icon>
		</v-btn>
		<v-btn @click="open()" color="error">
			{{ $t("label.assign_driver") }}
		</v-btn>

		<v-dialog v-model="dialog" width="800px" persistent>
			<v-form>
				<v-card :loading="loading">
					<v-card-title primary-title>
						{{ $t("label.assign_driver") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-subtitle class="py-0 grey lighten-4">
						<v-row no-gutters>
							<v-col cols="4">
								<small>
									{{ $t("Code") }}
								</small>
								<p class="pt-2 font-weight-medium">
									#{{ order.code }}
								</p>
							</v-col>
							<v-col cols="4">
								<small>
									{{ $t("Datetime") }}
								</small>
								<p class="pt-2 font-weight-medium">
									{{ order.date }} @
									{{ order.time }}
								</p>
							</v-col>
							<v-col cols="4">
								<small>
									{{ $t("Outlet") }}
								</small>
								<p class="pt-2 font-weight-medium">
									{{
										order.outlet ? order.outlet.name : null
									}}
								</p>
							</v-col>
						</v-row>
					</v-card-subtitle>
					<v-divider></v-divider>
					<v-card-text>
						<v-radio-group v-model="item.driver_id">
							<v-simple-table height="300px" fixed-header>
								<template v-slot:default>
									<thead>
										<tr>
											<th>{{ $t("label.select") }}</th>
											<th>{{ $t("Name") }}</th>
											<th>{{ $t("Phone") }}</th>
											<th>
												{{
													$t("label.today_task_count")
												}}
											</th>
											<th>
												{{
													$t(
														"label.weekly_task_count"
													)
												}}
											</th>
											<th>{{ $t("Status") }}</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="driver in drivers"
											:key="driver.name"
										>
											<td>
												<v-radio
													:value="driver.id"
												></v-radio>
											</td>
											<td>
												{{ driver.name }}
											</td>
											<td>
												{{ driver.phone }}
											</td>
											<td>
												{{ driver.today_task_count }}
											</td>
											<td>
												{{ driver.weakly_task_count }}
											</td>
											<td>
												{{ driver.status }}
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>
						</v-radio-group>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn @click="close()" text>
							<v-icon left>mdi-close</v-icon>
							{{ $t("Close") }}
						</v-btn>
						<v-btn
							@click="submit()"
							color="primary"
							:disabled="!item.driver_id"
							:loading="item.processing"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("label.assign") }}
						</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
	</div>
</template>

<script>
export default {
	props: ["order"],
	data() {
		return {
			dialog: false,
			loading: false,
			drivers: [],
			item: this.$inertia.form({
				driver_id: null,
				order_id: this.order.id,
			}),
		};
	},
	methods: {
		async open() {
			try {
				this.dialog = true;
				this.loading = true;
				this.drivers = [];
				const response = await axios.get(
					this.$route(
						"tenant.drivers.available",
						this.$page.props.tenant.id
					)
				);
				if (response.data.success) {
					this.drivers = response.data.data;
				} else {
					alert(rsponse.data.data);
				}
			} finally {
				this.loading = false;
			}
		},
		close() {
			this.dialog = false;
		},
		submit() {
			this.item.post(
				this.$route(
					"tenant.drivers.assign",
					this.$page.props.tenant.id
				),
				{
					onSuccess: () => this.close(),
				}
			);
		},
	},
};
</script>